var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueBaseDialog',{ref:"VueBaseDialog",attrs:{"dialogConfig":_vm.dialogConfig}},[_c('iframe',{staticStyle:{"width":"70vw","height":"80vh"},attrs:{"src":_vm.dialogConfig.path,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }